export default {
    setSavedDispatches(state, payload) {
        state.savedDispatches = payload || [];
    },
    setCurrentDispatch(state, payload) {
        state.currentDispatch = payload;
    },
    setCurrentDispatchParameters(state, payload) {
        state.currentDispatch.parameters = {
            ...state.currentDispatch.parameters,
            ...payload,
        };
    },
    setCurrentDispatchSites(state, payload) {
        state.currentDispatch.selectedSites = payload || [];
    },
    setCurrentDispatchId(state, payload) {
        state.currentDispatch.dispatchId = payload;
    },
    setCurrentDispatchSupply(state, payload) {
        state.currentDispatch.supply = payload || {};
    },
    setCurrentDispatchDeliveryParams(state, payload) {
        state.currentDispatch.deliveryParams = payload || {};
    },
    resetCurrentDispatch(state) {
        state.currentDispatch = {
            dispatchId: null,
            name: '',
            parameters: {
                dispatchDate: null,
                deliveryMethod: 'tanker',
                // Multi-select. An empty list means "every product".
                product: [],
                operator: [],
                area: [],
                maxDte: null,
                minUllage: null,
                maxFillPct: 95,
            },
            selectedSites: [],
            supply: {},
            deliveryParams: {},
        };
    },
};
